/*
Swaps image loading from "lazy" to "eager" in Firefox.
This fixes layout bugs caused by miscalculated heights.

These only seem to happen on long pages like resources guides,
which got random space at the top of the page when scrolling
past lazy loaded images
*/

import asap from '@js/asap.js';

if (/Firefox/.test(navigator.userAgent)) {
	asap('img[loading=lazy]', img => img.loading = 'eager');
}